import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import AuthLayout from '../../../components/auth/AuthLayout';

const SignupBusinessDocuments = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { mobile, businessDetails } = location.state || {};
  const [selfie, setSelfie] = useState(null);
  const [document, setDocument] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!mobile) {
      navigate('/signup', { replace: true });
    }
  }, [mobile, navigate]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!selfie || !document) {
      toast.error('Please upload both selfie and business document');
      return;
    }

    setLoading(true);

    try {
      // TODO: Replace with actual API call for final signup
      // const response = await authServices.completeSignup({ mobile, businessDetails, selfie, document });

      await new Promise(resolve => setTimeout(resolve, 1500));

      const demoCredentials = {
        mobile,
        uniqueId: 'DEMO' + Math.random().toString(36).substr(2, 9).toUpperCase(),
        password: 'Demo@' + Math.random().toString(36).substr(2, 6),
        pin: Math.floor(100000 + Math.random() * 900000).toString(),
      };

      toast.success('Registration completed successfully');
      navigate('/signup/success', {
        state: { credentials: demoCredentials }
      });
    } catch (error) {
      toast.error('Failed to complete registration. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Upload business documents"
      subtitle="Upload a selfie and your business proof"
      onBack={() => navigate(-1)}
    >
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label">Selfie</label>
          <input
            type="file"
            accept="image/*"
            className="form-input"
            onChange={(event) => setSelfie(event.target.files?.[0] || null)}
            required
          />
        </div>
        <div className="form-group">
          <label className="form-label">Business Proof</label>
          <input
            type="file"
            className="form-input"
            onChange={(event) => setDocument(event.target.files?.[0] || null)}
            required
          />
        </div>
        <button type="submit" className="signin-btn" disabled={loading}>
          {loading ? 'Uploading...' : 'Submit Registration'}
        </button>
      </form>
    </AuthLayout>
  );
};

export default SignupBusinessDocuments;


